import { render, staticRenderFns } from "./modal-aml.vue?vue&type=template&id=da49748e&"
import script from "./modal-aml.vue?vue&type=script&lang=js&"
export * from "./modal-aml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports